import { FRAMEWORK_LABELS, FRAMEWORK_ORDER, type FrameworkId } from "./frameworkCatalogue";

/**
 * A parenthesised pointer to the clauses a page serves, in the standard the organisation actually holds.
 * The references given are ISO 27001's, so they are quoted only while it is enrolled; otherwise the text
 * names the organisation's enrolled standards in neutral words (never a standard it has not chosen).
 */
export function iso27001Citation(enrolled: ReadonlySet<string>, refs: string): string {
  if (enrolled.has("iso27001")) return ` (ISO 27001 ${refs})`;
  const names = FRAMEWORK_ORDER.filter((id: FrameworkId) => enrolled.has(id)).map((id) => FRAMEWORK_LABELS[id]);
  return names.length > 0 ? ` (the matching requirements of ${names.length > 3 ? "your standards" : names.join(", ")})` : "";
}
